import { GlBadge, GlIcon, GlLink, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import CommitPopover from '../../../../vue_shared/components/commit_popover.vue?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__ } from '~/locale';
import LinkCell from '../../../runner/components/cells/link_cell.vue?vue3';
import { SUCCESS_STATUS } from '../../../constants';
export default {
    name: 'JobCell',
    iconSize: 12,
    i18n: {
        stuckText: s__('Jobs|Job is stuck. Check runners.')
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        CommitPopover,
        GlBadge,
        GlIcon,
        GlLink,
        LinkCell
    },
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    computed: {
        jobId () {
            const id = getIdFromGraphQLId(this.job.id);
            return `#${id}`;
        },
        jobPath () {
            return this.job.detailedStatus?.detailsPath;
        },
        jobRef () {
            return this.job?.refName;
        },
        jobCommit () {
            return this.job.shortSha;
        },
        jobCommitObject () {
            return this.job.pipeline?.commit;
        },
        jobCommitPath () {
            return this.job.commitPath;
        },
        jobRefPath () {
            return this.job.refPath;
        },
        jobTags () {
            return this.job.tags;
        },
        createdByTag () {
            return this.job.createdByTag;
        },
        triggered () {
            return this.job.triggered;
        },
        isManualJob () {
            return this.job.manualJob;
        },
        successfulJob () {
            return this.job.status === SUCCESS_STATUS;
        },
        showAllowedToFailBadge () {
            return this.job.allowFailure && !this.successfulJob;
        },
        isScheduledJob () {
            return Boolean(this.job.scheduledAt);
        },
        canReadJob () {
            return this.job?.userPermissions?.readBuild;
        },
        jobStuck () {
            return this.job?.stuck;
        },
        popoverTargetId () {
            return `pipeline-commit-popover-${this.jobCommitObject?.sha}`;
        }
    }
};
